// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/rfi_feedback.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
import { RfiFeedbackAdoption, RfiFeedbackHistory, RfiFeedbackVersion } from "../../datagateway/v1/rfi_feedback_pb";
/**
 * @generated from message mono.projectdata.v1.RecordRfiFeedbackVersionRequest
 */ export class RecordRfiFeedbackVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordRfiFeedbackVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordRfiFeedbackVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordRfiFeedbackVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordRfiFeedbackVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string submission_id = 2;
   */ _define_property(this, "submissionId", ""), /**
   * @generated from field: string prior_version_id = 3;
   */ _define_property(this, "priorVersionId", ""), /**
   * @generated from field: string body = 4;
   */ _define_property(this, "body", ""), /**
   * @generated from field: string request_id = 5;
   */ _define_property(this, "requestId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordRfiFeedbackVersionRequest, "runtime", proto3);
_define_property(RecordRfiFeedbackVersionRequest, "typeName", "mono.projectdata.v1.RecordRfiFeedbackVersionRequest");
_define_property(RecordRfiFeedbackVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "prior_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RecordRfiFeedbackVersionResponse
 */ export class RecordRfiFeedbackVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordRfiFeedbackVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordRfiFeedbackVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordRfiFeedbackVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordRfiFeedbackVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiFeedbackVersion version = 1;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordRfiFeedbackVersionResponse, "runtime", proto3);
_define_property(RecordRfiFeedbackVersionResponse, "typeName", "mono.projectdata.v1.RecordRfiFeedbackVersionResponse");
_define_property(RecordRfiFeedbackVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: RfiFeedbackVersion
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AdoptRfiFeedbackRequest
 */ export class AdoptRfiFeedbackRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdoptRfiFeedbackRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdoptRfiFeedbackRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdoptRfiFeedbackRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdoptRfiFeedbackRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string source_version_id = 2;
   */ _define_property(this, "sourceVersionId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string target_kind = 4;
   */ _define_property(this, "targetKind", ""), /**
   * @generated from field: string target_id = 5;
   */ _define_property(this, "targetId", ""), /**
   * @generated from field: string target_field = 6;
   */ _define_property(this, "targetField", ""), /**
   * @generated from field: string expected_target_version_id = 7;
   */ _define_property(this, "expectedTargetVersionId", ""), /**
   * @generated from field: string proposed_text = 8;
   */ _define_property(this, "proposedText", ""), /**
   * @generated from field: string request_id = 9;
   */ _define_property(this, "requestId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdoptRfiFeedbackRequest, "runtime", proto3);
_define_property(AdoptRfiFeedbackRequest, "typeName", "mono.projectdata.v1.AdoptRfiFeedbackRequest");
_define_property(AdoptRfiFeedbackRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "target_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "target_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "target_field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "expected_target_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "proposed_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AdoptRfiFeedbackResponse
 */ export class AdoptRfiFeedbackResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdoptRfiFeedbackResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdoptRfiFeedbackResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdoptRfiFeedbackResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdoptRfiFeedbackResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiFeedbackAdoption adoption = 1;
   */ _define_property(this, "adoption", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdoptRfiFeedbackResponse, "runtime", proto3);
_define_property(AdoptRfiFeedbackResponse, "typeName", "mono.projectdata.v1.AdoptRfiFeedbackResponse");
_define_property(AdoptRfiFeedbackResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "adoption",
            kind: "message",
            T: RfiFeedbackAdoption
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetRfiFeedbackHistoryRequest
 */ export class GetRfiFeedbackHistoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiFeedbackHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiFeedbackHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiFeedbackHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiFeedbackHistoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiFeedbackHistoryRequest, "runtime", proto3);
_define_property(GetRfiFeedbackHistoryRequest, "typeName", "mono.projectdata.v1.GetRfiFeedbackHistoryRequest");
_define_property(GetRfiFeedbackHistoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetRfiFeedbackHistoryResponse
 */ export class GetRfiFeedbackHistoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiFeedbackHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiFeedbackHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiFeedbackHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiFeedbackHistoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiFeedbackHistory history = 1;
   */ _define_property(this, "history", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiFeedbackHistoryResponse, "runtime", proto3);
_define_property(GetRfiFeedbackHistoryResponse, "typeName", "mono.projectdata.v1.GetRfiFeedbackHistoryResponse");
_define_property(GetRfiFeedbackHistoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "history",
            kind: "message",
            T: RfiFeedbackHistory
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProposalRfiHistoryRequest
 */ export class ListProposalRfiHistoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalRfiHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalRfiHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalRfiHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalRfiHistoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string proposal_project_id = 1;
   */ _define_property(this, "proposalProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalRfiHistoryRequest, "runtime", proto3);
_define_property(ListProposalRfiHistoryRequest, "typeName", "mono.projectdata.v1.ListProposalRfiHistoryRequest");
_define_property(ListProposalRfiHistoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProposalRfiHistoryResponse
 */ export class ListProposalRfiHistoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalRfiHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalRfiHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalRfiHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalRfiHistoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RfiFeedbackHistory histories = 1;
   */ _define_property(this, "histories", []), /**
   * @generated from field: int32 readable_count = 2;
   */ _define_property(this, "readableCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalRfiHistoryResponse, "runtime", proto3);
_define_property(ListProposalRfiHistoryResponse, "typeName", "mono.projectdata.v1.ListProposalRfiHistoryResponse");
_define_property(ListProposalRfiHistoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "histories",
            kind: "message",
            T: RfiFeedbackHistory,
            repeated: true
        },
        {
            no: 2,
            name: "readable_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * Only active linked Pursuits with independent update+sensitive grants appear.
 *
 * @generated from message mono.projectdata.v1.ListRfiFeedbackTargetsRequest
 */ export class ListRfiFeedbackTargetsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiFeedbackTargetsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiFeedbackTargetsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiFeedbackTargetsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiFeedbackTargetsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiFeedbackTargetsRequest, "runtime", proto3);
_define_property(ListRfiFeedbackTargetsRequest, "typeName", "mono.projectdata.v1.ListRfiFeedbackTargetsRequest");
_define_property(ListRfiFeedbackTargetsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RfiFeedbackTarget
 */ export class RfiFeedbackTarget extends Message {
    static fromBinary(bytes, options) {
        return new RfiFeedbackTarget().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiFeedbackTarget().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiFeedbackTarget().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiFeedbackTarget, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string capture_name = 2;
   */ _define_property(this, "captureName", ""), /**
   * @generated from field: string kind = 3;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string id = 4;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string field = 5;
   */ _define_property(this, "field", ""), /**
   * @generated from field: string label = 6;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string current_text = 7;
   */ _define_property(this, "currentText", ""), /**
   * @generated from field: string expected_version_id = 8;
   */ _define_property(this, "expectedVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiFeedbackTarget, "runtime", proto3);
_define_property(RfiFeedbackTarget, "typeName", "mono.projectdata.v1.RfiFeedbackTarget");
_define_property(RfiFeedbackTarget, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "current_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "expected_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiFeedbackTargetsResponse
 */ export class ListRfiFeedbackTargetsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiFeedbackTargetsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiFeedbackTargetsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiFeedbackTargetsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiFeedbackTargetsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.RfiFeedbackTarget targets = 1;
   */ _define_property(this, "targets", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiFeedbackTargetsResponse, "runtime", proto3);
_define_property(ListRfiFeedbackTargetsResponse, "typeName", "mono.projectdata.v1.ListRfiFeedbackTargetsResponse");
_define_property(ListRfiFeedbackTargetsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "targets",
            kind: "message",
            T: RfiFeedbackTarget,
            repeated: true
        }
    ]));
